import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["icon", "label", "inputValue", "format", "classes", "styles", "placeholder", "hasFocus", "currency", "inputType", "errorMessage", "validationFunction", "transformationFunction", "onInputChange", "onPasswordShown", "passwordType", "required", "autoComplete", "id", "dataCy", "tooltipHint"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Icon, TooltipLabel } from '../../subkit-ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Primary UI component for user interaction
 */
export var Input = function Input(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      _ref$inputValue = _ref.inputValue,
      inputValue = _ref$inputValue === void 0 ? '' : _ref$inputValue,
      format = _ref.format,
      classes = _ref.classes,
      styles = _ref.styles,
      placeholder = _ref.placeholder,
      _ref$hasFocus = _ref.hasFocus,
      hasFocus = _ref$hasFocus === void 0 ? false : _ref$hasFocus,
      currency = _ref.currency,
      inputType = _ref.inputType,
      errorMessage = _ref.errorMessage,
      validationFunction = _ref.validationFunction,
      transformationFunction = _ref.transformationFunction,
      onInputChange = _ref.onInputChange,
      onPasswordShown = _ref.onPasswordShown,
      passwordType = _ref.passwordType,
      required = _ref.required,
      autoComplete = _ref.autoComplete,
      id = _ref.id,
      _ref$dataCy = _ref.dataCy,
      dataCy = _ref$dataCy === void 0 ? '' : _ref$dataCy,
      tooltipHint = _ref.tooltipHint,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState({
    passwordShown: false,
    value: inputValue
  }),
      localState = _useState[0],
      setLocalState = _useState[1];

  var updateLocalState = function updateLocalState(updates) {
    var newState = _objectSpread(_objectSpread({}, localState), updates);

    setLocalState(newState);
  };

  var isValid = localState.value && validationFunction ? validationFunction(localState.value) : true;
  var showIcon = icon && icon.name !== '';
  var inputRef = useRef(null);
  var passwordShown = localState.passwordShown,
      value = localState.value;
  var finalType = inputType === 'password' ? passwordShown ? 'text' : 'password' : inputType;
  var computedInputVal = inputValue ? inputValue : '';
  useEffect(function () {
    if (hasFocus && inputRef.current) {
      inputRef.current.focus();
    }

    updateLocalState({
      value: inputValue
    });
  }, [computedInputVal, hasFocus]);

  var handleOnChange = function handleOnChange(event) {
    var v = transformationFunction ? transformationFunction(event.target.value) : event.target.value;
    updateLocalState({
      value: v
    });

    if (onInputChange) {
      onInputChange(event.target.name, v);
    }
  };

  var togglePasswordVisibility = function togglePasswordVisibility() {
    var newVal = !passwordShown;
    updateLocalState({
      passwordShown: newVal
    });

    if (onPasswordShown) {
      onPasswordShown(newVal);
    }
  };

  var roundedStyles = {
    borderWidth: '1px',
    borderRadius: '4px',
    paddingTop: '.75rem',
    paddingBottom: '.75rem'
  };
  var flatStyles = {
    borderTop: 'none',
    borderRight: 'none',
    borderLeft: 'none',
    borderBottomWidth: '1px',
    paddingTop: '.05rem',
    paddingBottom: '.05rem'
  };

  var borderLessStyles = _objectSpread(_objectSpread({}, roundedStyles), {}, {
    outline: 'none',
    border: 'none'
  });

  var rounded = format === 'rounded';
  var flat = format === 'flat';
  var borderLess = format === 'border-less';
  var iconPassword = passwordType && passwordType === 'icon';
  return /*#__PURE__*/_jsxs("div", {
    className: "my1 ".concat(classes && classes.container),
    style: _objectSpread({}, styles && styles.container),
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex",
      children: [/*#__PURE__*/_jsxs("label", {
        className: classNames('h4 my1 fw-500 justify-between', {
          block: label,
          'display-none': !label,
          flex: label
        }),
        children: [/*#__PURE__*/_jsx("span", {
          children: label
        }), /*#__PURE__*/_jsx("span", {
          className: classNames('clickable', {
            'display-none': iconPassword || inputType !== 'password'
          }),
          onClick: togglePasswordVisibility,
          children: passwordShown ? 'Hide' : 'Show'
        })]
      }), tooltipHint && /*#__PURE__*/_jsx(TooltipLabel, {
        tooltip: tooltipHint
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: classNames('flex items-center', {
        h4: rounded || borderLess,
        h2: flat
      }),
      children: [/*#__PURE__*/_jsx("span", {
        className: classNames({
          'display-none': !currency
        }),
        style: {
          marginRight: '-1rem',
          marginBottom: '.1rem'
        },
        children: currency
      }), /*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({
        className: classNames("pl1 fit bs-solid ".concat(classes && classes.input), {
          'border-neutral-200': isValid,
          'bc-danger': !isValid,
          h4: rounded || borderLess,
          h2: flat,
          pr3: showIcon,
          pr1: !showIcon,
          'bg-white': !currency,
          'bg-transparent': currency
        }),
        style: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
          paddingLeft: currency ? '1rem' : '.5rem'
        }, rounded && roundedStyles), flat && flatStyles), borderLess && borderLessStyles), styles && styles.input),
        placeholder: placeholder,
        ref: inputRef
      }, props), {}, {
        type: finalType,
        value: value,
        onChange: handleOnChange,
        id: id,
        autoComplete: autoComplete,
        required: required,
        "data-cy": dataCy
      })), showIcon && /*#__PURE__*/_jsx("span", {
        style: {
          marginLeft: '-25px'
        },
        children: /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, icon), {}, {
          type: "solid",
          onClick: iconPassword && togglePasswordVisibility
        }))
      })]
    }), !isValid && /*#__PURE__*/_jsx("span", {
      className: "c-danger block mt-0.5",
      children: errorMessage
    })]
  });
};